import React, {Component} from 'react'
import PropTypes from 'prop-types'
import AppContainer from '../../components/_common/_containers/AppContainer'
import NRTFormContainer from '../../components/_common/_form/_containers/FormContainer'
import {Helmet} from 'react-helmet'
import {FormCompleteRegistration} from "./organisms/FormCompleteRegistration";
import NRTButton from "../../components/_common/_buttons/Button";
import Spinner from "../../components/_common/Spinner";


class CompleteRegistrationTemplate extends Component {


    render() {
        const {
            title,
            loginBackground,
            awaiting ,
        } = this.props


        return (
            <AppContainer
                showFooter={false}
                showHeader={false}
                style={{
                    background: `url(${loginBackground})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                }}>
                <Helmet>
                    <meta charSet="utf-8"/>
                    <title>Complete seu cadastro </title>
                </Helmet>
                <div className="nrt-login-page" style={{zIndex: 333}}>

                    {/*<Spinner/>*/}


                    <div className={'card'}>

                        <NRTFormContainer title={'Complete seu cadastro'}
                                          formStyle={{
                                              background: 'rgba(255,255,255,.6)',
                                          }}>

                            <FormCompleteRegistration/>

                            <NRTButton onClick={this.props.onSubmit }
                                content={awaiting ?  <Spinner width={32}/> : 'Enviar' }
                            />


                        </NRTFormContainer>
                    </div>
                </div>

            </AppContainer>
        )
    }
}

CompleteRegistrationTemplate.propTypes = {
    loginBackground: PropTypes.string.isRequired,
    onSubmit: PropTypes.func.isRequired ,
    awaiting: PropTypes.bool.isRequired ,
}

CompleteRegistrationTemplate.defaultProps = {}


export default CompleteRegistrationTemplate



// WEBPACK FOOTER //
// ./src/_pages/CompleteRegistration/template.js